var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Box } from "./..";
export var Backdrop = function (props) { return (React.createElement(Box, { className: "static-backdrop", "aria-hidden": true, lss: __assign({ zIndex: -1, position: 'fixed', right: 0, bottom: 0, top: 0, left: 0, bg: 'opacityDark', WebkitTapHighlightColor: 'transparent', touchAction: 'none' }, props.lss) })); };
//# sourceMappingURL=Backdrop.js.map